import { useEffect, useRef } from 'react';

/** `refresh` decides for itself whether a given cycle is safe to run. */
export function useSilentRefresh(refresh: () => void, intervalMs: number, enabled: boolean): void {
  const latest = useRef(refresh);
  latest.current = refresh;

  useEffect(() => {
    if (!enabled) return;
    const runIfVisible = () => {
      if (document.visibilityState === 'visible') latest.current();
    };
    const timer = window.setInterval(runIfVisible, intervalMs);
    document.addEventListener('visibilitychange', runIfVisible);
    window.addEventListener('focus', runIfVisible);
    return () => {
      window.clearInterval(timer);
      document.removeEventListener('visibilitychange', runIfVisible);
      window.removeEventListener('focus', runIfVisible);
    };
  }, [enabled, intervalMs]);
}
